export const SET_SEARCH_TERM = 'SET_SEARCH_TERM';
export const TOGGLE_OPEN_SEARCH_TERM = 'TOGGLE_OPEN_SEARCH_TERM';
